import { createTheme } from '@mui/material/styles';

declare module '@mui/material/styles' {
  interface TypeBackground {
    card?: string;
  }
}

export const lightTheme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#ff6600',
      // main: '#0f284c',
    },
    secondary: {
      main: '#0f284c',
      // main: '#ff6600',
    },
    background: {
      paper: 'white',
      card: '#f8f9fa',
    },
    grey: {
      50: '#f8f9fa',
      100: '#e9ecef',
      200: '#dee2e6',
      300: '#ced4da',
      400: '#adb5bd',
      500: '#6c757d',
      600: '#495057',
      700: '#343a40',
      800: '#212529',
      900: '#121416',
    },
  },
  components: {
    MuiDrawer: {
      styleOverrides: {
        paper: {
          backgroundColor: '#0F284C',
          color: 'white',
        },
      },
    },
    // MuiButton: {
    //   styleOverrides: {
    //     outlined: {
    //       borderColor: '#0D2748',
    //       borderRadius: '5px',
    //       '&:hover': {
    //         backgroundColor: '#D9D9D9',
    //         color: 'white',
    //       },
    //     },
    //     root: {
    //       '&.Mui-selected': {
    //         backgroundColor: '#0D2748',
    //         color: 'white',
    //       },
    //     },
    //   },
    // },
  },
});

export const darkTheme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#ff6600',
    },
    secondary: {
      main: '#0f284c',
    },
    background: {
      paper: '#1a1a1a',
      card: '#2d2d2d',
    },
    grey: {
      50: '#f8f9fa',
      100: '#e9ecef',
      200: '#dee2e6',
      300: '#ced4da',
      400: '#adb5bd',
      500: '#6c757d',
      600: '#495057',
      700: '#343a40',
      800: '#212529',
      900: '#121416',
    },
  },
  components: {
    MuiDrawer: {
      styleOverrides: {
        paper: {
          backgroundColor: '#0F284C',
          color: 'white',
        },
      },
    },
  },
});

// Default export for backward compatibility
export const theme = lightTheme;

// MUI typography font size
// h1: 6.0rem (~96px)
// h2: 3.75rem (~60px)
// h3: 3.0rem (~48px)
// h4: 2.125rem (~34px)
// h5: 1.5rem (~24px)
// h6: 1.25rem (~20px)
// subtitle1: 1.0rem (~16px)
// subtitle2: 0.875rem (~14px)
// body1: 1.0rem (~16px)
// body2: 0.875rem (~14px)
// caption: 0.75rem (~12px)
// overline: 0.75rem (~12px)
